import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { FormArray, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';

interface WeekDay {
  id: number;
  code: string;
  short: string;
  full: string;
}

interface TimePeriod {
  id: number;
  code: string;
  name: string;
  range: string;
}

@Component({
  selector: 'app-availability',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  templateUrl: './availability.component.html',
  styleUrl: './availability.component.scss'
})
export class AvailabilityComponent {
  @Input() availability!: FormArray;
  @Input() availabilityShow: number[] | undefined;
  @Input() editable: boolean = false; // Por padrão será modo visualizar
  @Output() availabilityChange = new EventEmitter<FormArray>();

  weekDays: WeekDay[] = [
    { id: 2, code: 'mon', short: 'SEG', full: 'Segunda' },
    { id: 3, code: 'tue', short: 'TER', full: 'Terça' },
    { id: 4, code: 'wed', short: 'QUA', full: 'Quarta' },
    { id: 5, code: 'thu', short: 'QUI', full: 'Quinta' },
    { id: 6, code: 'fri', short: 'SEX', full: 'Sexta' },
    { id: 7, code: 'sat', short: 'SÁB', full: 'Sábado' },
    { id: 8, code: 'sun', short: 'DOM', full: 'Domingo' }
  ];

  timePeriods: TimePeriod[] = [
    { id: 1, code: 'morning', name: 'Manhã', range: '06:00 - 12:00' },
    { id: 2, code: 'afternoon', name: 'Tarde', range: '12:00 - 18:00' },
    { id: 3, code: 'evening', name: 'Noite', range: '18:00 - 00:00' }
  ];

  onAvailabilityChange(newAvailability: any) {
    this.availability = newAvailability;
  }

  selectPlace(place: number) {
    // Só permite seleção se estiver no modo editável
    if (!this.availability || !this.editable) return;

    const index = this.availability.value.indexOf(place);
    if (index !== -1) {
      this.availability.removeAt(index);
    } else {
      this.availability.push(new FormControl(place));
    }
  }

  isSlotSelected(dayId: number, periodId: number): boolean {
    const place = parseInt(`${dayId}${periodId}`);
    if (this.availabilityShow && this.availabilityShow.length > 0) {
      return this.availabilityShow.some(item => item === place);
    }
    if (this.availability && this.availability.value) {
      return this.availability.value.includes(place);
    }
    return false;
  }

  getSlotTooltip(dayName: string, periodName: string): string {
    return `${dayName} - ${periodName}`;
  }

  getSlotAriaLabel(dayName: string, periodName: string, isSelected: boolean): string {
    const status = isSelected ? 'selecionado' : 'disponível';
    return `${dayName} ${periodName} - ${status}`;
  }

  trackByDayId(index: number, day: WeekDay): number {
    return day.id;
  }

  trackByPeriodId(index: number, period: TimePeriod): number {
    return period.id;
  }

  selectAllWeekdays(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.availability || !this.editable) return;

    // Clear current selection
    this.availability.clear();

    // Add all weekday slots (Monday to Friday, all periods)
    for (let dayId = 2; dayId <= 6; dayId++) {
      for (let periodId = 1; periodId <= 3; periodId++) {
        const place = parseInt(`${dayId}${periodId}`);
        this.availability.push(new FormControl(place));
      }
    }

  }

  selectWeekend(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.availability || !this.editable) return;

    // Clear current selection
    this.availability.clear();

    // Add weekend slots (Saturday and Sunday, all periods)
    for (let dayId = 7; dayId <= 8; dayId++) {
      for (let periodId = 1; periodId <= 3; periodId++) {
        const place = parseInt(`${dayId}${periodId}`);
        this.availability.push(new FormControl(place));
      }
    }

  }

  clearAll(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.availability || !this.editable) return;

    this.availability.clear();
  }

  findPlace(place: number) {
    if (this.availabilityShow && this.availabilityShow.length > 0) {
      return this.availabilityShow.some(item => item === place)
        ? 'lightgreen'
        : 'lightgray';
    }
    if (this.availability && this.availability.value) {
      return this.availability.value.includes(place) ? 'lightgreen' : 'lightgray';
    }
    return 'lightgray';
  }
}
